import IntegrationsApi from './api/IntegrationsApi';

export const loadFrontEndIntegrations = async (d: Document) => {
	const auth = JSON.parse(localStorage.getItem('auth'));

	if (auth) {
		try {
			const frontEndIntegrations = await IntegrationsApi.fetchIntegrations(
				auth.authorizationToken,
			);

			const injectableScripts =
				frontEndIntegrations.data.externalServiceIntegrations;

			if (injectableScripts && injectableScripts.length) {
				let fePluginsScripts = document.createElement('div');
				fePluginsScripts.setAttribute('id', 'fe-plugins-scripts');
				injectableScripts.forEach((injectableScript) => {
					if (injectableScript && injectableScript.url) {
						let script = d.createElement('script');
						script.type = 'text/javascript';
						script.async = true;
						script.src = injectableScript.url;
						fePluginsScripts.appendChild(script);
					}
				});
				d.getElementsByTagName('head')[0].appendChild(fePluginsScripts);
			}
		} catch (error) {
			console.error('Unable to fetch integrations', error);
		}
	}
};

export const removeFrontEndIntegrations = (d: Document) => {
	try {
		d.getElementById('fe-plugins').innerHTML = '';
	} catch (error) {
		console.error('Unable to remove integrations', error);
	}
};
